"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fileSaver = _interopRequireDefault(require("file-saver"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Config = function Config(sceneWrapper) {
  var _this = this;

  _classCallCheck(this, Config);

  this.getNodes = function () {
    return _this.scene.allNodes.filter(function (node) {
      return node.nodeType === 'node' || node.nodeType === 'initialNode';
    });
  };

  this.getShops = function () {
    return _this.scene.assets;
  };

  this.getDirectory = function () {
    var directory = {
      cameraDirectoryPos: ''
    };
    directory.cameraDirectoryPos = _this.scene.camera.position;
    directory.cameraNorth = _this.scene.cameraNorth;
    directory.nodeSize = _this.sceneWrapper.nodeSize;
    directory.nodeColor = _this.sceneWrapper.nodeColor;
    return directory;
  };

  this.updateShopsFromConfig = function () {
    var arrayShops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return new Promise(function (resolve) {
      // Apply transformation to shops
      Promise.all(arrayShops.map(function (shop) {
        return new Promise(function (innerResolve) {
          if (shop.assetId) {
            var position = shop.position ? new BABYLON.Vector3(shop.position.x, shop.position.y, shop.position.z) : null;

            var foundShop = _this.scene.getMeshByName(shop.assetId);

            if (position && foundShop) {
              foundShop.setAbsolutePosition(position);

              var foundAsset = _this.scene.assets.find(function (asset) {
                return asset.assetId === shop.assetId;
              });

              foundAsset.displayName = shop.displayName || foundAsset.displayName;
              foundAsset.cmsID = shop.cmsID || foundAsset.cmsID;
              foundAsset.position = shop.position || foundAsset.position;
              foundAsset.assetType = shop.assetType || foundAsset.assetType;
              foundAsset.showName = shop.showName || foundAsset.showName;
              foundAsset.showLogo = shop.showLogo || foundAsset.showLogo;
              foundAsset.transferFloors = shop.transferFloors || foundAsset.transferFloors;
              foundAsset.uncharted = shop.uncharted || foundAsset.uncharted;
            }
          }

          innerResolve();
        });
      })).then(resolve);
    });
  };

  this.createNodeFromConfig = function () {
    var arrayNs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return new Promise(function (resolve) {
      arrayNs.forEach(function (node) {
        var newNode = {
          id: node.nodeId,
          position: new BABYLON.Vector3(node.position.x, node.position.y, node.position.z),
          targetNodes: node.targetNodes,
          targetAssets: node.targetAssets,
          orientation: node.orientation,
          terminalID: node.terminalID,
          floor: node.floor
        };

        if (node.nodeType === 'node') {
          _this.sceneWrapper.addNode(newNode);
        } else {
          _this.sceneWrapper.addInitialNode(newNode);
        }
      });
      resolve();
    });
  };

  this.updateCameraFromConfig = function (info) {
    if (info) {
      _this.scene.cameraNorth = info.cameraNorth;
    }
  };

  this.loadConfiguration = function (config) {
    return new Promise(function (resolve) {
      if (config.directory.nodeSize) {
        _this.sceneWrapper.nodeSize = config.directory.nodeSize;
      }

      if (config.directory.nodeColor) {
        _this.sceneWrapper.nodeColor = config.directory.nodeColor;
      }

      resolve(_this.createNodeFromConfig(config.nodes).then(function () {
        return _this.updateShopsFromConfig(config.shops);
      }).then(function () {
        return _this.updateCameraFromConfig(config.directory);
      }));
    });
  };

  this.saveConfiguration = function (fileName) {
    var configObj = {
      nodes: _this.getNodes(),
      shops: _this.getShops(),
      directory: _this.getDirectory()
    };
    var blob = new Blob([JSON.stringify(configObj)], {
      type: 'application/json'
    });
    (0, _fileSaver["default"])(blob, "".concat(fileName, ".json"));
  };

  this.saveCamera = function () {
    _this.scene.cameraNorth = {
      alpha: _this.scene.camera.alpha,
      beta: _this.scene.camera.beta
    };
  };

  this.sceneWrapper = sceneWrapper;
  this.scene = sceneWrapper.scene;
};

exports["default"] = Config;